<template>
<div class="calc_count">
    <h4>Оставшиеся расчёты: <router-link to='/payment' class="accents">{{calcCount.count}}</router-link>, Действие пакета: <router-link to='/payment' class="accents">по {{moment(calcCount.to_date).format('DD.MM.YYYY')}} г.</router-link></h4>
</div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'calc_count',
  components:{},
  data:()=>({
      moment
  }),
  methods:{
      async getBackCount(){
        await this.$store.dispatch('GET_CALC_COUNT')
      }
  },
  async created(){
      await this.getBackCount()
  },
  computed:{
      calcCount(){return this.$store.getters.getCalcCount}
  },
}
</script>
<style lang="sass" scoped>
.calc_count
  padding: 0 20px
.accents
  color: var(--v-primary-base)
  text-decoration: none
</style>
